import React, { useState } from 'react';
import CmsPage from '../../shared/cmsPage/components/CmsPage';
import { syncTrainingLocations, syncUsers } from '../api/ptsiApi';
import log from '../../logger.js';
import Button from 'react-bootstrap/Button';

const PtsiPluginPage = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const handleSync = async () => {
    try {
      setLoading(true);
      setError('');
      setSuccess('');
      await syncTrainingLocations();
      setSuccess('Training locations synced successfully');
    } catch (err) {
      log.error('ERROR: ', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const handleSyncUsers = async () => {
    try {
      setLoading(true);
      setError('');
      setSuccess('');
      await syncUsers();
      setSuccess('Users synced successfully');
    } catch (err) {
      log.error('ERROR: ', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CmsPage title={'PTSI'}>
      <div style={{ marginBottom: '1rem' }}>
        <Button onClick={() => handleSync()} disabled={loading}>
          Sync Training Locations
        </Button>
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <Button onClick={() => handleSyncUsers()} disabled={loading}>
          Sync Users
        </Button>
      </div>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {success && <div style={{ color: 'green' }}>{success}</div>}
    </CmsPage>
  );
};

export default PtsiPluginPage;
